/**
 * Truncates a client name if it exceeds the maximum length
 * @param clientName - The client name to truncate
 * @returns The truncated client name with ellipsis if it exceeds maxLength, otherwise the original name
 */
export const truncateClientName = (clientName: string | undefined): string | undefined => {
  const maxLength = 17;
  const cutOffLength = 14;

  if (!clientName || clientName.length <= maxLength) {
    return clientName;
  }

  return clientName.substring(0, cutOffLength) + '...';
};
